import { getTourSteps, tourOptions } from 'components/shared/GuidedTour/GuidedTour.steps';
import { guidedTourApi, useTourSteps } from 'components/shared/GuidedTour/useTourSteps';
import { useCallback, useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useShepherd } from 'react-shepherd';
import { StepOptions } from 'shepherd.js';

export const useGuidedTour = (isEnabled: boolean = true) => {
  const Shepherd = useShepherd();
  const intl = useIntl();

  const { stepIds, refreshTourSteps } = useTourSteps();

  const onStepCompleted = useCallback((stepId: string) => {
    guidedTourApi.saveCompletedStep(stepId).subscribe();
  }, []);

  const stepOptions = useMemo<StepOptions[]>(
    () => getTourSteps(stepIds, intl, onStepCompleted),
    [intl, onStepCompleted, stepIds],
  );

  useEffect(() => {
    if (isEnabled) {
      const tour = new Shepherd.Tour(tourOptions);
      tour.addSteps(stepOptions);
      refreshTourSteps().then(() => {
        tour.start();
      });
    }
  }, [refreshTourSteps, isEnabled, Shepherd, stepOptions]);
};
